"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Loading = exports.Loading = /*#__PURE__*/ (0, _react.memo)(()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.CircularProgress, {
            color: "primary"
        })
    }));
